export const getModuleClassNames = (classNamesArray: string[]): string => classNamesArray.join(" ");
